import { render } from "./AdminRoute.vue?vue&type=template&id=7e78d58c"
import script from "./AdminRoute.vue?vue&type=script&lang=js"
export * from "./AdminRoute.vue?vue&type=script&lang=js"

import "./AdminRoute.vue?vue&type=style&index=0&id=7e78d58c&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__